export interface IWorkGroup {
  id?: string;
  name?: string;
  note?: string | null;
  IsDeleted?: boolean;
}

export const defaultValue: Readonly<IWorkGroup> = {
  IsDeleted: false,
};
